import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Stores() {
  const [stores, setStores] = useState([]);
  useEffect(() => {
    api.get("/stores").then((r) => setStores(r.data)).catch(() => {});
  }, []);

  return (
    <PublicLayout>
      <section className="border-b border-border bg-card">
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="label-eyebrow text-secondary mb-2">Vendora Storefronts</div>
          <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter text-primary leading-none">Discover independent British shops.</h1>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        {stores.map((s) => (
          <Link key={s.id} to={`/store/${s.slug}`} className="v-card overflow-hidden p-0 flex flex-col group" data-testid={`store-card-${s.slug}`}>
            <div className="aspect-[16/9] bg-muted overflow-hidden">
              <img src={s.banner_url} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
            </div>
            <div className="p-5 flex-1">
              <div className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">vendra.uk/store/{s.slug}</div>
              <h3 className="font-display text-xl font-bold text-primary mt-1">{s.name}</h3>
              <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{s.tagline}</p>
              <div className="mt-4 text-sm text-secondary font-medium flex items-center gap-1">Visit store <ArrowRight size={14} /></div>
            </div>
          </Link>
        ))}
      </section>
    </PublicLayout>
  );
}
